(() => {
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  document.documentElement.classList.remove('no-js');
  // Preserve old language query links while using native locale URLs thereafter.
  const legacy = new URL(location.href);
  if (legacy.searchParams.has('lang')) {
    const language = legacy.searchParams.get('lang'); legacy.searchParams.delete('lang');
    const path = legacy.pathname.replace(/^\/zh(?:-tw)?(?=\/|$)/i, '') || '/';
    legacy.pathname = language === 'zh' ? '/zh' + path : path;
    location.replace(legacy.pathname + legacy.search + legacy.hash); return;
  }
  document.querySelectorAll('form[action*="localization"]').forEach(form => {
    form.addEventListener('submit', () => { const input=form.querySelector('[name="return_to"]'); if(input) input.value=location.pathname+location.search; });
  });
  const videos = all('video.editorial-video');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  videos.forEach(video => {
    video.muted = true;
    if (reducedMotion || navigator.connection?.saveData) { video.pause(); video.removeAttribute('autoplay'); }
    else video.play().catch(() => {});
  });
  const menu = document.querySelector('#MobileMenu');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');
  const setMenu = (open) => {
    if (!menu || !openButton) return;
    menu.hidden = !open;
    openButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
    if (open) closeButton?.focus();
  };
  openButton?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  all('[data-menu-link]').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu && !menu.hidden) setMenu(false);
  });

  const header = document.querySelector('[data-header]');
  if ('IntersectionObserver' in window && header) {
    const hero = document.querySelector('.showcase-hero');
    if (hero) new IntersectionObserver(([entry]) => header.classList.toggle('is-condensed', !entry.isIntersecting), { rootMargin: '-90px 0px 0px' }).observe(hero);
  }
})();
